export function formatterRUT(rut: string) {
  // Eliminar posibles puntos o guiones que ya tenga el RUT, pero mantener la 'k' o 'K'
  const cleanRut = rut.replace(/[^0-9kK]/g, '');

  // Dividir el RUT en número y dígito verificador
  const body = cleanRut.slice(0, -1);
  const dv = cleanRut.slice(-1).toUpperCase(); // Convertir a mayúscula para estandarizar

  // Agregar puntos cada tres dígitos desde la derecha
  const formatBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  // Retornar el RUT formateado con el dígito verificador
  return `${formatBody}-${dv}`;
}
